export default __webpack_public_path__ + "static/media/hydro.5587415b.svg";